import { oc } from '@orpc/contract';
import { getInspectionInputSchema, inspectionOutputSchema } from '../schemas/inspections.schemas.js';
export const getInspectionContract = oc
    .route({
    method: 'GET',
    path: '/inspections',
    tags: ['Inspections'],
    summary: 'Read the inspection of an estimate or a stock vehicle',
})
    .input(getInspectionInputSchema)
    .output(inspectionOutputSchema);
//# sourceMappingURL=get-inspection.contract.js.map